import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { EDIT_ATTRIBUTE } from './actionTypes'

export const editAttribute = (attribute: any): AppThunk => {
  return dispatch => {
    return dispatch(
      request(`/organizations/:organizationId/usersattributes/${attribute.id}`, EDIT_ATTRIBUTE, {
        method: 'PUT',
        body: attribute
      })
    )
  }
}
